import { computed, ref, watch, } from 'vue';
export function useVirtualTable(items, props) {
    const itemsPerPage = computed(() => {
        if (typeof props.itemsPerPage === 'number') {
            return props.itemsPerPage;
        }
        return parseInt(props.itemsPerPage, 10);
    });
    // 페이지 넘버 관리
    const pageNumber = ref(1);
    const increasePageNumber = () => {
        pageNumber.value += 1;
    };
    const resetPageNumber = () => {
        pageNumber.value = 1;
    };
    // 옵저버 DOM 관리
    const observerRef = ref();
    // 옵저버 중복작동 방지
    const preventRef = ref(true);
    const setPreventRef = (value) => {
        preventRef.value = value;
    };
    // 옵저버 핸들러
    const observerHandler = (entries) => {
        const target = entries[0];
        if (target.isIntersecting && preventRef.value) {
            setPreventRef(false);
            increasePageNumber();
        }
    };
    // 배열 시작 index
    const startIndex = ref(0);
    // 배열 종료 index
    const stopIndex = computed({
        get() {
            return Math.min(items.value.length, startIndex.value + (pageNumber.value * itemsPerPage.value));
        },
        set() { },
    });
    // 보여야 하는 최종 배열
    const visibleItems = computed({
        get() {
            return items.value.slice(startIndex.value, stopIndex.value);
        },
        set() { },
    });
    // 마지막 페이지인지 여부
    const isLastPage = computed({
        get() {
            return items.value.length === visibleItems.value.length;
        },
        set() { },
    });
    // 최종 배열이 정해지면 옵저버 다시 작동
    watch(() => visibleItems.value, () => {
        setPreventRef(true);
    });
    const observer = ref(new IntersectionObserver(observerHandler, {
        threshold: 0.75,
    }));
    const disconnectObserver = () => {
        observer.value.disconnect();
        resetPageNumber();
    };
    const connectObserver = () => {
        if (!observerRef.value) {
            return;
        }
        disconnectObserver();
        observer.value.observe(observerRef.value);
    };
    return {
        visibleItems,
        observerRef,
        disconnectObserver,
        connectObserver,
        isLastPage,
    };
}
